(function () {
    function getVariants(scope) {
        const script = scope.querySelector('[data-product-variants-json]');
        if (!script) return [];

        try {
            return JSON.parse(script.textContent);
        } catch (error) {
            console.warn('Erreur JSON variantes produit', error);
            return [];
        }
    }

    function syncBuyButtons(scope) {
        if (!scope) return;

        const variantInput = scope.querySelector('input[name="id"]');
        const controls = scope.querySelector('[data-add-to-cart-controls]');
        const submitButton = scope.querySelector('button[name="add"]');
        const productSection = scope.closest('section[id^="MainProduct-"], .product, .product__info-container') || document;
        const unavailableMarker = productSection.querySelector('[data-product-unavailable-marker]') || document.querySelector('[data-product-unavailable-marker]');

        if (!variantInput || !controls) return;

        const variants = getVariants(scope);
        const currentVariant = variants.find(function (variant) {
            return String(variant.id) === String(variantInput.value);
        });

        if (!currentVariant) return;

        const isAvailable = currentVariant.available === true;

        controls.classList.toggle('hidden', !isAvailable);
        variantInput.disabled = !isAvailable;

        if (submitButton) {
            submitButton.disabled = !isAvailable;
            submitButton.setAttribute('aria-disabled', isAvailable ? 'false' : 'true');
        }

        if (unavailableMarker) {
            unavailableMarker.classList.toggle('product_unavailable', !isAvailable);
            unavailableMarker.classList.toggle('product_unavailable-placeholder', isAvailable);
        }
    }

    function syncAllBuyButtons() {
        document.querySelectorAll('[data-product-buy-buttons]').forEach(syncBuyButtons);
    }

    document.addEventListener('DOMContentLoaded', syncAllBuyButtons);

    document.addEventListener('change', function (event) {
        if (
        event.target.matches('input[type="radio"], select') ||
        event.target.closest('variant-radios, variant-selects')
        ) {
        setTimeout(syncAllBuyButtons, 0);
        }
    });

    document.addEventListener('click', function (event) {
        if (
            event.target.closest('input[type="radio"]') ||
            event.target.closest('label') ||
            event.target.closest('variant-radios') ||
            event.target.closest('variant-selects')
        ) {
            setTimeout(syncAllBuyButtons, 50);
        }
    });

    document.addEventListener('variant:change', function () {
        setTimeout(syncAllBuyButtons, 0);
    });
})();